/** Lao copy for the audit log screen (workspace Activity log and Control Center). */
export const laoAudit: Record<string, string> = {
  'Audit log': 'ບັນທຶກການກວດສອບ',
  'Append-only, hash-chained record of every change in this workspace: who, what, when and the exact values changed.':
    'ບັນທຶກທຸກການປ່ຽນແປງໃນພື້ນທີ່ນີ້ ແບບເພີ່ມໄດ້ຢ່າງດຽວ ແລະ ເຊື່ອມດ້ວຍລະຫັດແຮຊ: ໃຜ, ເຮັດຫຍັງ, ເມື່ອໃດ ແລະ ຄ່າທີ່ປ່ຽນແທ້.',
  'Append-only, hash-chained record of every change across all workspaces and platform administration.':
    'ບັນທຶກທຸກການປ່ຽນແປງໃນທຸກພື້ນທີ່ ແລະ ການບໍລິຫານລະບົບ ແບບເພີ່ມໄດ້ຢ່າງດຽວ ແລະ ເຊື່ອມດ້ວຍລະຫັດແຮຊ.',
  'You do not have permission to view the activity log.': 'ທ່ານບໍ່ມີສິດເບິ່ງປະຫວັດການໃຊ້ງານ.',
  'Verify integrity': 'ກວດຄວາມຖືກຕ້ອງ',
  'Export CSV': 'ສົ່ງອອກ CSV',
  'Export JSON': 'ສົ່ງອອກ JSON',
  'Audit log exported': 'ສົ່ງອອກບັນທຶກແລ້ວ',
  'Entries recorded': 'ລາຍການທີ່ບັນທຶກ',
  Since: 'ເລີ່ມແຕ່',
  'Latest entry': 'ລາຍການຫຼ້າສຸດ',
  'People and systems': 'ຜູ້ໃຊ້ ແລະ ລະບົບ',
  'Search actor, action, record or details…': 'ຄົ້ນຫາຜູ້ດຳເນີນການ, ການກະທຳ, ລາຍການ ຫຼື ລາຍລະອຽດ…',
  Period: 'ໄລຍະເວລາ',
  'All time': 'ທັງໝົດ',
  'Last 7 days': '7 ມື້ຜ່ານມາ',
  'Last 90 days': '90 ມື້ຜ່ານມາ',
  'Custom range': 'ກຳນົດເອງ',
  Action: 'ການກະທຳ',
  'All actions': 'ທຸກການກະທຳ',
  'Record type': 'ປະເພດລາຍການ',
  'All record types': 'ທຸກປະເພດລາຍການ',
  Actor: 'ຜູ້ດຳເນີນການ',
  Everyone: 'ທຸກຄົນ',
  Record: 'ລາຍການ',
  Platform: 'ລະບົບ',
  'Platform administration': 'ການບໍລິຫານລະບົບ',
  'All workspaces': 'ທຸກພື້ນທີ່',
  Details: 'ລາຍລະອຽດ',
  When: 'ເວລາ',
  Event: 'ເຫດການ',
  'Seq.': 'ລຳດັບ',
  'Just now': 'ຫາກໍ່ນີ້',
  'min ago': 'ນາທີກ່ອນ',
  'h ago': 'ຊົ່ວໂມງກ່ອນ',
  'd ago': 'ມື້ກ່ອນ',
  System: 'ລະບົບ',
  'Show details': 'ສະແດງລາຍລະອຽດ',
  'Hide details': 'ເຊື່ອງລາຍລະອຽດ',
  'No entries': 'ບໍ່ມີລາຍການ',
  'Nothing matches these filters. Try a longer period or clear a filter.':
    'ບໍ່ມີລາຍການທີ່ກົງກັບຕົວກອງ. ລອງໄລຍະເວລາທີ່ຍາວຂຶ້ນ ຫຼື ລຶບຕົວກອງ.',
  Showing: 'ສະແດງ',
  'newest entries': 'ລາຍການຫຼ້າສຸດ',
  entries: 'ລາຍການ',
  'Load older entries': 'ໂຫຼດລາຍການເກົ່າກວ່າ',
  'Timestamp (UTC)': 'ເວລາ (UTC)',
  'Local time': 'ເວລາທ້ອງຖິ່ນ',
  'Entry ID': 'ລະຫັດລາຍການ',
  'Chain position': 'ຕຳແໜ່ງໃນລະບົບເຊື່ອມ',
  'Before hash chaining': 'ກ່ອນເລີ່ມເຊື່ອມລະຫັດແຮຊ',
  Changes: 'ການປ່ຽນແປງ',
  Field: 'ຊ່ອງຂໍ້ມູນ',
  Before: 'ກ່ອນ',
  After: 'ຫຼັງ',
  'No further details were recorded for this entry.': 'ບໍ່ມີລາຍລະອຽດເພີ່ມເຕີມສຳລັບລາຍການນີ້.',
  'Show this record’s history': 'ສະແດງປະຫວັດຂອງລາຍການນີ້',
  'Show everything by this actor': 'ສະແດງທຸກຢ່າງທີ່ຜູ້ນີ້ເຮັດ',
  'Show raw JSON': 'ສະແດງ JSON',
  'Hide raw JSON': 'ເຊື່ອງ JSON',
  'Copy entry': 'ສຳເນົາລາຍການ',
  'Entry copied': 'ສຳເນົາລາຍການແລ້ວ',
  'Integrity check failed': 'ກວດພົບບັນຫາຄວາມຖືກຕ້ອງ',
  'Integrity verified: no entry has been changed or removed':
    'ກວດແລ້ວ: ບໍ່ມີລາຍການໃດຖືກແກ້ໄຂ ຫຼື ລຶບ',
  'chained entries checked': 'ລາຍການທີ່ກວດແລ້ວ',
  chains: 'ຊຸດເຊື່ອມ',
  head: 'ລ່າສຸດ',
  'older entries predate chaining': 'ລາຍການເກົ່າກ່ອນເລີ່ມເຊື່ອມ',
  'First at': 'ເລີ່ມທີ່',
  'The chain is broken.': 'ການເຊື່ອມຂາດ.',
  'An entry is missing from the sequence.': 'ມີລາຍການຫາຍໄປຈາກລຳດັບ.',
  'An entry does not link to the one before it.': 'ມີລາຍການທີ່ບໍ່ເຊື່ອມກັບລາຍການກ່ອນໜ້າ.',
  'An entry was changed after it was written.': 'ມີລາຍການຖືກແກ້ໄຂຫຼັງຈາກບັນທຶກແລ້ວ.',
  'An entry was written outside the audit chain.': 'ມີລາຍການຖືກບັນທຶກນອກລະບົບເຊື່ອມ.',
};
